import { MfcDetailsLayout } from "@features/layout/mfcDetails";

export const MfcDetailsPage = () => {
  return <MfcDetailsLayout />;
};
